import { render, staticRenderFns } from "./KeywordSearchModal.vue?vue&type=template&id=4af57f50"
import script from "./KeywordSearchModal.vue?vue&type=script&lang=js"
export * from "./KeywordSearchModal.vue?vue&type=script&lang=js"
import style0 from "./KeywordSearchModal.vue?vue&type=style&index=0&id=4af57f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports